import React, { PureComponent } from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'

import { Layout, Container, Header } from 'src/components/Layout'
import { withRouter } from 'react-router-dom'
import Button from 'src/components/Button'
import Disclaimer from 'src/modals/Disclaimer'

import intlMessages from '../../translations'

class PinkSlipAddressConfirmation extends PureComponent {
  state = {
    confirmed: false,
    showDisclaimer: false,
  }

  componentDidMount() {
    const { address } = this.props

    if (!address) {
      this.handleBack()
    }
  }

  componentDidUpdate(prevProps) {
    if (!this.props.submitting && prevProps.submitting) {
      this.setState({
        showDisclaimer: false,
        confirmed: true,
      })
    }
  }

  formatAddressObject = item => {
    return `${item.address}, ${item.city}, ${item.zip}, ${item.state}, ${item.country}`
  }

  handleBack = () => {
    const { history } = this.props

    history.push('/documents/mail-pinkslip')
  }

  handleConfirmation = () => {
    this.setState({
      showDisclaimer: true,
    })
  }

  handleCloseDisclaimer = () => {
    this.setState({
      showDisclaimer: false,
    })
  }

  handleSubmitDisclaimer = () => {
    const { address, sendPinkSlipAddress } = this.props

    sendPinkSlipAddress(address)
  }

  renderThankYou = address => {
    return (
      <React.Fragment>
        <h2>
          <FormattedMessage id='app.document.pinkSlip.success' defaultMessage='Thank you' />
        </h2>
        <p>
          <FormattedMessage
            id='app.document.pinkSlip.successBody'
            defaultMessage='We are mailing your pink slip to '
          />
          <br />
          {this.formatAddressObject(address)}
        </p>
      </React.Fragment>
    )
  }

  renderConfirmation = () => {
    return (
      <React.Fragment>
        <h2>
          <FormattedMessage
            id='app.document.pinkSlip.pleaseConfirm'
            defaultMessage='Please confirm'
          />
        </h2>
        <p></p>
        <Button onClick={this.handleConfirmation}>
          <FormattedMessage id='app.document.pinkSlips.submit' defaultMessage='Submit' />
        </Button>
      </React.Fragment>
    )
  }

  render() {
    const { address, intl, submitting } = this.props
    const { showDisclaimer, confirmed } = this.state
    return (
      <Layout>
        <Header
          onBack={this.handleBack}
          title={intl.formatMessage(intlMessages.documentPinkSlipHeadline)}
        />
        <Container padder>
          <div style={{ textAlign: 'center' }}>
            {confirmed ? this.renderThankYou(address) : this.renderConfirmation(address)}
          </div>
          <Disclaimer
            visible={showDisclaimer}
            loading={submitting}
            onClose={this.handleCloseDisclaimer}
            onSubmit={this.handleSubmitDisclaimer}
          />
        </Container>
      </Layout>
    )
  }
}

export default withRouter(injectIntl(PinkSlipAddressConfirmation))
